import React from 'react';
import { IndexRoute, Route } from 'react-router';

import { SINGLE_OFFICE_MODE } from './config';
import MainLayout from './pages/MainLayout';
import OfficesPage from './pages/Offices';
import ServicesPage from './pages/Services';
import IntervalsPage from './pages/Intervals';
import ReservationPage from './pages/Reservation';
import NotFoundPage from './pages/NotFound';
import EmailConfirm from './pages/EmailConfirm';
import DeleteReservation from './pages/DeleteReservation';
import StatsOfficePage from './pages/StatsOfficePage';



export default (
  <Route path="/" component={MainLayout}>
    <IndexRoute component={SINGLE_OFFICE_MODE ? ServicesPage : OfficesPage } />
    { !SINGLE_OFFICE_MODE &&
      <Route path="/" component={OfficesPage} />
    }
    <Route path="/stats/:stats" component={SINGLE_OFFICE_MODE ? ServicesPage : OfficesPage} />
    <Route path={SINGLE_OFFICE_MODE ? "/" : "/office/:officeId" } component={ServicesPage} />
    <Route path="/office/:officeId/service/:serviceId" component={IntervalsPage} />
    <Route path="/office/:officeId/service/:serviceId/interval/:intervalId" component={ReservationPage} />
    <Route path="/email-confirmation/:emailHash" component={EmailConfirm} />
    <Route path="/delete-reservation/:reservationHash" component={DeleteReservation} />
    <Route path="/stats-office/:officeId" component={StatsOfficePage} />
    <Route path="*" component={NotFoundPage} />
  </Route>
);
